import * as angular from 'angular';

import { ComponentDefinition, ApplicationUserViewModel } from '../../models';

class UserPopoverController implements angular.IComponentController {
    readonly user: ApplicationUserViewModel;

    static $inject = [];
    
}

export const wtUserPopover: ComponentDefinition = {
    componentId: 'wtUserPopover',
    controller: UserPopoverController,
    template: require('./userPopover.component.html'),
    controllerAs: 'vm',
    bindings: {
        user: '<'
    }
};